export default "__VITE_ASSET__DU461yNe__$_?nuxt_component=async&nuxt_component_name=SvgoCommonNoData&nuxt_component_export=default__"